'use client'

import { useSuspenseQuery } from '@tanstack/react-query'

import { useResponsive } from '@dafiti/closet-ui/hooks'
import { MobileNavigationMenu } from '@/components/PageHeader/Menu/MobileNavigationMenu'
import { WideNavigationMenu } from '@/components/PageHeader/Menu/WideNavigationMenu'
import { useAppLayoutContext } from '@/providers/AppLayoutProvider'
import { getCommonsHeaderQueryOptions } from '@/queries/header'

export const Menu = () => {
  const { options } = useAppLayoutContext()

  const { isMobile } = useResponsive()

  const { data } = useSuspenseQuery(
    getCommonsHeaderQueryOptions({
      apiOrigin: options.bffBaseUrl,
      cacheTime: options.cacheTime,
    }),
  )

  const menuItems = data.menu[0]?.content.items || []

  return (
    <>
      {/* Render if is not mobile or null (to avoid layout changes when server side rendering) */}
      {isMobile !== true && <WideNavigationMenu data={menuItems} />}

      {/* Render mobile menu if the user agent is mobile or null (to avoid layout changes when server side rendering) */}
      {isMobile !== false && <MobileNavigationMenu data={menuItems} />}

      {/* mobile menu separator */}
      <div
        aria-hidden="true"
        className="border-b-[1px] border-b-gray-200 lg:hidden"
      />
    </>
  )
}
